/* Seyasha finish layer: swipe bars under rails, "See all" cards at the end of panel rails, and the
   category jump bar on the homepage. Rails are filled by seyasha-merch.js, which fires "sy:cards". */
(function () {
  'use strict';
  var D = document, W = window;
  var me = D.currentScript;
  var JUMP = !!(me && me.hasAttribute('data-sy-jump'));
  var reduced = !!(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var ICON = '<svg class="sy-ic" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9 5 7 7-7 7"/></svg>';
  var RAILS = '.sy-band .sy-rail, .sy-shelf__rail';

  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function hasCards(ul) {
    for (var i = 0; i < ul.children.length; i++) {
      var li = ul.children[i];
      if (li.classList.contains('sy-end') || li.classList.contains('sy-skel')) continue;
      if (li.querySelector('.sy-card, [data-sy-card]')) return true;
    }
    return false;
  }

  /* ---------- swipe bar ---------- */
  function paint(ul) {
    var bar = ul.__syBar;
    if (!bar) return;
    var sw = ul.scrollWidth, cw = ul.clientWidth, wrap = bar.parentNode;
    if (!cw || sw <= cw + 4) { wrap.classList.add('is-off'); return; }
    wrap.classList.remove('is-off');
    var w = cw / sw, max = sw - cw, x = Math.min(1, Math.max(0, Math.abs(ul.scrollLeft) / max));
    bar.style.width = (w * 100).toFixed(2) + '%';
    bar.style.transform = 'translateX(' + (x * (1 / w - 1) * 100).toFixed(2) + '%)';
  }

  /* ---------- "See all" card ---------- */
  function endCard(ul) {
    var box = ul.closest('[data-sy-more]');
    if (!box) return;
    var li = null;
    for (var i = 0; i < ul.children.length; i++) if (ul.children[i].classList.contains('sy-end')) li = ul.children[i];
    if (!hasCards(ul)) { if (li) ul.removeChild(li); return; }
    if (!li) {
      var n = +box.getAttribute('data-sy-more-n') || 0;
      li = D.createElement('li');
      li.className = 'sy-end';
      li.innerHTML = '<a class="sy-end__a" href="' + esc(box.getAttribute('data-sy-more')) + '"><span class="sy-end__ic">' + ICON +
        '</span><span class="sy-end__t">See all</span>' + (n > 0 ? '<span class="sy-end__n">' + n + ' styles</span>' : '') + '</a>';
    }
    if (ul.lastElementChild !== li) ul.appendChild(li);
  }

  function bind(ul) {
    if (ul.__syBound) { endCard(ul); paint(ul); return; }
    ul.__syBound = 1;
    var prog = ul.nextElementSibling;
    ul.__syBar = prog && prog.classList.contains('sy-prog') ? prog.querySelector('i') : null;
    var t = 0;
    ul.addEventListener('scroll', function () {
      if (t) return;
      t = W.requestAnimationFrame(function () { t = 0; paint(ul); });
    }, { passive: true });
    /* the rail script swaps or re-orders cards; keep the "See all" card last and the bar in step */
    if ('MutationObserver' in W) {
      var q = 0;
      new MutationObserver(function () {
        if (q) return;
        q = W.requestAnimationFrame(function () { q = 0; endCard(ul); paint(ul); });
      }).observe(ul, { childList: true });
    }
    endCard(ul);
    paint(ul);
  }

  function initRails() { $$(RAILS).forEach(bind); }

  /* ---------- category jump bar ---------- */
  var jump = null;
  function Jump() {
    var nav = D.createElement('nav');
    nav.className = 'sy-jump';
    nav.setAttribute('aria-label', 'Jump to a category');
    nav.innerHTML = '<div class="sy-jump__in"></div>';
    var inner = nav.firstChild;
    D.body.appendChild(nav);
    var hdr = D.querySelector('.section-header') || D.querySelector('sticky-header');
    var targets = [], chips = [], on = false, act = -1, key = '', hold = 0, lastBuild = 0;

    function headH() {
      if (!hdr) return 0;
      var r = hdr.getBoundingClientRect();
      return Math.max(0, Math.min(r.bottom, W.innerHeight / 3));
    }
    function build() {
      lastBuild = Date.now();
      var list = $$('[data-sy-jump]').filter(function (el) { return !el.hidden && el.offsetParent !== null; });
      var k = list.map(function (el) { return el.id + ':' + el.getAttribute('data-sy-jump'); }).join('|');
      if (k === key) return;
      key = k;
      targets = list;
      inner.innerHTML = list.map(function (el, i) {
        return '<button type="button" class="sy-jump__c" data-i="' + i + '">' + esc(el.getAttribute('data-sy-jump')) + '</button>';
      }).join('');
      chips = $$('.sy-jump__c', inner);
      act = -1;
    }
    function setAct(a) {
      if (a === act) return;
      act = a;
      chips.forEach(function (c, i) {
        c.classList.toggle('is-act', i === a);
        if (i === a) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
      });
      var c = chips[a];
      if (!c) return;
      /* centre the active chip; a plain jump, because smooth scrolling of a strip inside a fixed bar is unreliable in Safari */
      var cr = c.getBoundingClientRect(), ir = inner.getBoundingClientRect();
      inner.scrollLeft = Math.max(0, inner.scrollLeft + (cr.left - ir.left) - (inner.clientWidth - cr.width) / 2);
    }
    function show(v) {
      if (v === on) return;
      on = v;
      nav.classList.toggle('is-on', v);
    }
    function update() {
      if (Date.now() - lastBuild > 1200) build();
      if (targets.length < 3) { show(false); return; }
      var hh = headH(), bh = nav.offsetHeight;
      nav.style.top = hh + 'px';
      var first = targets[0].getBoundingClientRect(), last = targets[targets.length - 1].getBoundingClientRect();
      show(first.top < hh + bh + 8 && last.bottom > hh + bh + 120);
      if (Date.now() < hold) return;
      var line = hh + bh + W.innerHeight * 0.3, a = 0;
      for (var i = 0; i < targets.length; i++) if (targets[i].getBoundingClientRect().top <= line) a = i;
      setAct(a);
    }
    inner.addEventListener('click', function (e) {
      var c = e.target.closest ? e.target.closest('.sy-jump__c') : null;
      if (!c) return;
      var i = +c.getAttribute('data-i'), t = targets[i];
      if (!t) return;
      var y = t.getBoundingClientRect().top + (W.pageYOffset || D.documentElement.scrollTop) - headH() - nav.offsetHeight - 12;
      hold = Date.now() + (reduced ? 100 : 1100);
      setAct(i);
      W.scrollTo({ top: Math.max(0, y), behavior: reduced ? 'auto' : 'smooth' });
    });
    var t = 0;
    function tick() { if (t) return; t = W.requestAnimationFrame(function () { t = 0; update(); }); }
    W.addEventListener('scroll', tick, { passive: true });
    W.addEventListener('resize', function () { key = ''; build(); tick(); }, { passive: true });
    build();
    update();
    return { refresh: function () { key = ''; build(); tick(); } };
  }

  function start() {
    initRails();
    if (JUMP && !(W.Shopify && Shopify.designMode) && D.querySelectorAll('[data-sy-jump]').length >= 3) jump = Jump();
  }
  D.addEventListener('sy:cards', function (e) {
    var ul = e.detail && e.detail.root;
    if (ul && ul.matches && ul.closest('.sy-band, .sy-shelf') && ul.matches('.sy-rail, .sy-shelf__rail')) bind(ul);
    if (jump) jump.refresh();
  });
  W.addEventListener('resize', function () { $$(RAILS).forEach(function (ul) { if (ul.__syBound) paint(ul); }); }, { passive: true });
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start); else start();
})();
